import React, { FC } from 'react';
import { Form, Select } from '@duxton-web/ui';
import uniq from 'lodash/uniq';
import { styled } from 'styled-components';

import Service, { Strategy } from '../../../../../lib/App';
import SectionCollapse from '../../../common/SectionCollapse';
import { ExpFormField } from '../../../helper/consts';

interface AdvancedConfigProps {
  strategy?: Strategy;
}

const AdvancedConfig: FC<AdvancedConfigProps> = ({ strategy }) => {
  const form = Form.useFormInstance();

  const geoHashFacets = ['lgh', 'dolgh'];
  const geoHashAssignableFacets = uniq(strategy.assignable)
    .map((item: any) => ({
      key: item,
      name: Service.cache!.getFacet(item)!.title,
    }))
    .filter(({ key }) => geoHashFacets.includes(key));

  return (
    <Wrapper>
      <SectionCollapse
        expandIconPosition="start"
        title="Advanced"
        ghost
        style={{ boxShadow: 'none' }}
        collapsible="header"
        defaultOpen
      >
        <Title>Assign By</Title>
        <ContentWrapper>
          <Form.Item
            style={{ marginBottom: 8 }}
            label={<InputLabel>Time</InputLabel>}
          >
            <InputContainer>
              <Select disabled value="time">
                <Select.Option value="time">Time</Select.Option>
              </Select>
            </InputContainer>
          </Form.Item>

          <Form.Item
            style={{ marginBottom: 8 }}
            label={<InputLabel>Geo Precision</InputLabel>}
            name={ExpFormField.STRATEGY.GEO_REGION}
            rules={[
              {
                required: true,
                message: 'Please select a geo region',
              },
            ]}
          >
            <InputContainer>
              <Select
                placeholder="Select geo region"
                options={[
                  { label: 'Geohash5', value: 5 },
                  { label: 'Geohash6', value: 6 },
                ]}
                onChange={(value) => {
                  form.setFieldValue(ExpFormField.STRATEGY.GEO_REGION, value);
                }}
              />
            </InputContainer>
          </Form.Item>

          <Form.Item
            style={{ marginBottom: 8 }}
            label={<InputLabel>Geo</InputLabel>}
            name={ExpFormField.STRATEGY.GEO_HASH}
            rules={[
              {
                required: true,
                message: 'Please select a geohash',
              },
            ]}
          >
            <InputContainer>
              <Select
                placeholder="Select geo hash"
                options={geoHashAssignableFacets.map(({ key, name }) => ({
                  label: name,
                  value: key,
                }))}
                onChange={(value) => {
                  form.setFieldValue(ExpFormField.STRATEGY.GEO_HASH, value);
                }}
              />
            </InputContainer>
          </Form.Item>
        </ContentWrapper>
      </SectionCollapse>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  & .ant-collapse .ant-collapse-content > .ant-collapse-content-box {
    padding: 16px 0;
  }
  & > .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding: 0;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  gap: 16px;
  justify-content: start;
  align-items: center;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
`;

const InputLabel = styled.div`
  font-size: 12px;
`;

const InputContainer = styled.div`
  width: 300px;
`;

export default AdvancedConfig;
